import * as api from "@hp/api-client";
import type { ClaimChatMessage, SendClaimChatMessageResponse } from "@hp/api-client";

/** Every message so far in this claim's bounded chat, oldest first. */
export async function listClaimChatMessages(claimId: string): Promise<ClaimChatMessage[]> {
  return api.listClaimChatMessages(claimId);
}

/** Sends a question about this claim and gets back both the stored user message and the answer. */
export async function sendClaimChatMessage(claimId: string, message: string): Promise<SendClaimChatMessageResponse> {
  return api.sendClaimChatMessage(claimId, message);
}
